export const MapZoom = {
  defaultZoom: 7,
  zoomOnStore: 12,
  zoomForTrackingInstaller: 14,
  geoLocationZoom: 10,
};

export default MapZoom;
